module.exports = __webpack_public_path__ + "static/media/solConfirmado.05224473.png";